import { WEIGHT_ITEM_CODE } from "@/shared/models/SectionSpec";
import type {
	ApplicableInspectionItem,
	InspectionWithValues,
	ProfileInspectionsResult,
} from "../models/Inspection";

interface SummaryItemsParams {
	inspections?: Pick<InspectionWithValues, "ProfileSpecId">[];
	applicableItemsBySpec?: ProfileInspectionsResult["applicableItemsBySpec"];
}

/** Use the largest displayed revision, not the union or the answered readings. */
export const getSummaryItems = ({
	inspections = [],
	applicableItemsBySpec,
}: SummaryItemsParams): ApplicableInspectionItem[] => {
	let selectedItems: ApplicableInspectionItem[] = [];
	for (const inspection of inspections) {
		const items = applicableItemsBySpec?.[inspection.ProfileSpecId];
		// On ties, keep the first sample (the service returns newest first).
		if (items && items.length > selectedItems.length) selectedItems = items;
	}
	return selectedItems;
};

/**
 * Weight can be measured even when the revision sets no weight limits, so a
 * measured weight is always shown.
 */
export const weightApplies = (
	specApplies: boolean | undefined,
	measuredLbsPerFoot: number | null | undefined,
) => (measuredLbsPerFoot != null ? true : specApplies);

export const hasWeightColumn = (
	summaryItems: Pick<ApplicableInspectionItem, "Code">[],
	inspections: Pick<InspectionWithValues, "MeasuredLbsPerFoot">[] = [],
) =>
	summaryItems.some((item) => item.Code === WEIGHT_ITEM_CODE) ||
	inspections.some((inspection) => inspection.MeasuredLbsPerFoot != null);
